export default {"src":"/_next/static/media/assumptions4.bf525073.svg","height":440,"width":640};